import { render, staticRenderFns } from "./PassengerPlacePicker.vue?vue&type=template&id=1a65f601&scoped=true"
import script from "./PassengerPlacePicker.vue?vue&type=script&lang=ts"
export * from "./PassengerPlacePicker.vue?vue&type=script&lang=ts"
import style0 from "./PassengerPlacePicker.vue?vue&type=style&index=0&id=1a65f601&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a65f601",
  null
  
)

export default component.exports